import React from "react"
import { Analytics } from "@vercel/analytics/react"
import { Header, Footer } from "./LandingPage"
import SEO from "./common/SEO"

interface DeviceCardProps {
  brand: string;
  models: string[];
}

const DeviceCard: React.FC<DeviceCardProps> = ({ brand, models }) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg">
      <h3 className="text-xl font-semibold mb-4">{brand}</h3>
      <ul className="space-y-2">
        {models.map((model, index) => (
          <li key={index} className="text-muted-foreground">{model}</li>
        ))}
      </ul>
    </div>
  )
}

const CompatibilityPage: React.FC = () => {
  const compatibleDevices: DeviceCardProps[] = [
    {
      brand: "Shearwater",
      models: [
        "Peregrine",
        "Peregrine TX",
        "Petrel",
        "Petrel 3",
        "Perdix",
        "Perdix 2",
        "NERD",
        "NERD 2",
        "Teric",
        "Tern",
        "Tern TX"
      ]
    },
    {
      brand: "Suunto",
      models: [
        "D5",
        "EON Steel",
        "EON Core"
      ]
    },
    {
      brand: "Cressi",
      models: [
        "Donatello",
        "Michelangelo",
        "Cartesio",
        "Neon",
        "Goa"
      ]
    },
    {
      brand: "Scubapro",
      models: [
        "G2",
        "G3"
      ]
    },
    {
      brand: "Aqualung",
      models: [
        "i200C",
        "i300C",
        "i770R",
        "i750C"
      ]
    },
    {
      brand: "Mares",
      models: [
        "Puck 4",
        "Sirius"
      ]
    }
  ];

  return (
    <div className="flex min-h-screen flex-col relative">
      <SEO path="/compatibility" />
      <Header />
      <main className="flex-1">
        <section className="container flex flex-col items-center justify-center space-y-4 pt-32 text-center">
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl">
            Compatible Dive Computers
          </h1>
          <p className="max-w-[600px] text-xl text-muted-foreground">
            Currents supports direct Bluetooth sync with these dive computers. 
            Don&apos;t see your device? <a href="mailto:hello@deepsealabs.co" className="text-[#1F80FF] hover:text-[#1F80FF]/80">Let us know!</a>
          </p>
        </section>

        <section className="container py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-[1200px] mx-auto">
            {compatibleDevices.map((device, index) => (
              <DeviceCard key={index} {...device} />
            ))}
          </div>
        </section>
      </main>
      <Footer />
      <Analytics />
    </div>
  )
}

export default CompatibilityPage